import React from 'react';
import Table from 'react-bootstrap/Table';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { reactLocalStorage } from 'reactjs-localstorage';

import CompanyAPI from '../../api/CompanyAPI';
import Display from '../../util/Display';
import ApiUiController from '../../controller/ApiUiController';
import Const from '../../util/Constants';
import Util from '../../util/Util';

class CompanyDetailsPreview extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { inApiCall: true, name: '', zone: '0~', admin_email: '',
      default_currency: 0, logo: '', updated: false, file: null };

    const model = reactLocalStorage.getObject(Const.Model).company;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
  }
  componentDidMount() { CompanyAPI.get(this.onReceived, this.onFail); }
  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  onReceived = res => { this.setState({ ...this.state, ...res });
  CompanyAPI.getLogo(this.onLogo, this.onFail); }
  onLogo = res => this.setState({ ...this.state, inApiCall: false, logo: res.logo });

  onChange = file => this.setState({ ...this.state, file: file, updated: file ? true : false });
  onSave = () => {
    this.setState({ ...this.state, inApiCall: true });
    CompanyAPI.putLogo(this.state.file, this.onSaveed, this.onFail);
  }
  onSaveed = () => { CompanyAPI.get(this.onReceived, this.onFail); }

  render() {

    if(!this.List) return null;

    const company = this.state;
    const options = reactLocalStorage.getObject(Const.Model).currency.options;
    const Currency = options.find(currency => currency.value === company.default_currency);
    const TimeZone = company.zone.split(Const.Opt);
        
    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row"><div className="col-md-6 pb-3"><h3>Company Detail</h3></div></div>
        </div>
        <ApiUiController inApiCall={this.state.inApiCall}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 preview">
                <Table  bordered>
                  <tbody>
                    <tr><td>Name</td><td>{company.name}</td></tr>
                    <tr><td>Admin Name</td><td>{company.admin_name}</td></tr>
                    <tr><td>Mobile</td><td>{`${company.code}-${company.admin_no}`}</td></tr>
                    <tr><td>Email</td><td>{company.admin_email}</td></tr>
                    <tr><td>Currency</td><td>{Currency ? Currency.label : '-'}</td></tr>
                    <tr>
                      <td>Time Zone</td>
                      <td>{Display.ModelLabelValue('zone', Number(TimeZone[0]))}</td>
                    </tr>
                    <tr>
                      <td>Logo</td>
                      <td>
                        <img src={company.logo} alt="logo" />
                        { this.Update &&
                          <FormControl type="file" onChange={evt => 
                            this.onChange(evt.target.files.length > 0
                              ? evt.target.files[0] : null)} />
                        }
                        { this.state.updated && this.Update &&
                          <Button onClick={this.onSave}> Update </Button> }
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </ApiUiController>
      </div>
    );
  }
}
export default CompanyDetailsPreview;
